<div *ngIf="show" [class]="customClass || 'chip'" [ngClass]="!customClass ? chipClass : null" role="status" [attr.title]="displayText">
  {{ displayText }}
  <img *ngIf="iconSrc" [src]="iconSrc" alt="icon" class="chip-icon" />
</div>
<div *ngIf="!show" [class]="customClass || 'chip placeholder'"></div>
